export default __webpack_public_path__ + "static/media/sms_icon_black.ee28f478.svg";